<template>
    <PageIndex/>
</template>

<script setup lang="ts">
    import PageIndex from "./pages/PageIndex.vue"
</script>

<style>
    .activeElement {
        cursor: pointer;
        color: var(--bs-link-color);
        border-bottom: 1px dashed var(--bs-link-color);
    }
</style>
